import {
  ANAL_BASIC_INFO_ERROR,
  ANAL_BASIC_INFO_REQUESTING,
  ANAL_BASIC_INFO_SUCCESS,
  ANAL_COMPANY_BASIC_ERROR,
  ANAL_COMPANY_BASIC_REQUESTING,
  ANAL_COMPANY_BASIC_SUCCESS,
  ANAL_COMPANY_BIGTRANS_ERROR,
  ANAL_COMPANY_BIGTRANS_REQUESTING,
  ANAL_COMPANY_BIGTRANS_SUCCESS,
  ANAL_COMPANY_EVENTS_ERROR,
  ANAL_COMPANY_EVENTS_REQUESTING,
  ANAL_COMPANY_EVENTS_SUCCESS,
  ANAL_COMPANY_HOLDER_ERROR,
  ANAL_COMPANY_HOLDER_REQUESTING,
  ANAL_COMPANY_HOLDER_SUCCESS,
  ANAL_COMPANY_INTRODUCTION_ERROR,
  ANAL_COMPANY_INTRODUCTION_REQUESTING,
  ANAL_COMPANY_INTRODUCTION_SUCCESS,
  ANAL_COMPANY_LEADER_ERROR,
  ANAL_COMPANY_LEADER_REQUESTING,
  ANAL_COMPANY_LEADER_SUCCESS,
  ANAL_COMPANY_RELATED_ERROR,
  ANAL_COMPANY_RELATED_REQUESTING,
  ANAL_COMPANY_RELATED_SUCCESS,
  ANAL_COMPANY_SAME_IND_ERROR,
  ANAL_COMPANY_SAME_IND_REQUESTING,
  ANAL_COMPANY_SAME_IND_SUCCESS,
  ANAL_DEL_FILTER_ERROR,
  ANAL_DEL_FILTER_REQUESTING,
  ANAL_DEL_FILTER_SUCCESS,
  ANAL_FILTER_ACT_ERROR,
  ANAL_FILTER_ACT_REQUESTING,
  ANAL_FILTER_ACT_SUCCESS,
  ANAL_FILTER_RANGE_ERROR,
  ANAL_FILTER_RANGE_REQUESTING,
  ANAL_FILTER_RANGE_SUCCESS,
  ANAL_FS_RATIO_ERROR,
  ANAL_FS_RATIO_REQUESTING,
  ANAL_FS_RATIO_SUCCESS,
  ANAL_INDEX_REAL_ERROR,
  ANAL_INDEX_REAL_REQUESTING,
  ANAL_INDEX_REAL_SUCCESS,
  ANAL_LICH_SU_GIA_ERROR,
  ANAL_LICH_SU_GIA_REQUESTING,
  ANAL_LICH_SU_GIA_SUCCESS,
  ANAL_NN_10DAY_ERROR,
  ANAL_NN_10DAY_REQUESTING,
  ANAL_NN_10DAY_SUCCESS,
  ANAL_NN_INDAY_ERROR,
  ANAL_NN_INDAY_REQUESTING,
  ANAL_NN_INDAY_SUCCESS,
  ANAL_PB_DONG_TIEN_ERROR,
  ANAL_PB_DONG_TIEN_REQUESTING,
  ANAL_PB_DONG_TIEN_SUCCESS,
  ANAL_RANK_FS_RATIO_ERROR,
  ANAL_RANK_FS_RATIO_REQUESTING,
  ANAL_RANK_FS_RATIO_SUCCESS,
  ANAL_SEC_LIST_ALL_ERROR,
  ANAL_SEC_LIST_ALL_REQUESTING,
  ANAL_SEC_LIST_ALL_SUCCESS,
  ANAL_SEC_OVERVIEW_ERROR,
  ANAL_SEC_OVERVIEW_REQUESTING,
  ANAL_SEC_OVERVIEW_SUCCESS,
  ANAL_STOCK_MATCH_PRICE_ERROR,
  ANAL_STOCK_MATCH_PRICE_REQUESTING,
  ANAL_STOCK_MATCH_PRICE_SUCCESS,
  ANAL_STOCK_MB_ACTIVE_ERROR,
  ANAL_STOCK_MB_ACTIVE_REQUESTING,
  ANAL_STOCK_MB_ACTIVE_SUCCESS,
  ANAL_STOCK_REAL_ERROR,
  ANAL_STOCK_REAL_REQUESTING,
  ANAL_STOCK_REAL_SUCCESS,
  ANAL_USER_FILTER_ERROR,
  ANAL_USER_FILTER_REQUESTING,
  ANAL_USER_FILTER_SUCCESS,
  ANAL_USER_SIGNAL_ERROR,
  ANAL_USER_SIGNAL_REQUESTING,
  ANAL_USER_SIGNAL_SUCCESS,
} from './constants';

/** chỉ số index realtime */
export const analSecListAllRequest = function analSecListAllRequest(params) {
  return {
    type: ANAL_SEC_LIST_ALL_REQUESTING,
    params,
  };
};

export const analSecListAllSuccess = function analSecListAllSuccess(resData) {
  return {
    type: ANAL_SEC_LIST_ALL_SUCCESS,
    resData,
  };
};

export const analSecListAllError = function analSecListAllError(error) {
  return {
    type: ANAL_SEC_LIST_ALL_ERROR,
    error,
  };
};

/** chỉ số index realtime */
export const analIndexRealRequest = function analIndexRealRequest(params) {
  return {
    type: ANAL_INDEX_REAL_REQUESTING,
    params,
  };
};

export const analIndexRealSuccess = function analIndexRealSuccess(resData) {
  return {
    type: ANAL_INDEX_REAL_SUCCESS,
    resData,
  };
};

export const analIndexRealError = function analIndexRealError(error) {
  return {
    type: ANAL_INDEX_REAL_ERROR,
    error,
  };
};

/** chỉ số chứng khoán realtime */
export const analStockRealRequest = function analStockRealRequest(params) {
  return {
    type: ANAL_STOCK_REAL_REQUESTING,
    params,
  };
};

export const analStockRealSuccess = function analStockRealSuccess(resData) {
  return {
    type: ANAL_STOCK_REAL_SUCCESS,
    resData,
  };
};

export const analStockRealError = function analStockRealError(error) {
  return {
    type: ANAL_STOCK_REAL_ERROR,
    error,
  };
};

/** khớp lệnh theo bước giá */
export const analStockMatchPriceRequest = function analStockMatchPriceRequest(params) {
  return {
    type: ANAL_STOCK_MATCH_PRICE_REQUESTING,
    params,
  };
};

export const analStockMatchPriceSuccess = function analStockMatchPriceSuccess(resData) {
  return {
    type: ANAL_STOCK_MATCH_PRICE_SUCCESS,
    resData,
  };
};

export const analStockMatchPriceError = function analStockMatchPriceError(error) {
  return {
    type: ANAL_STOCK_MATCH_PRICE_ERROR,
    error,
  };
};

/** mua bán chủ động */
export const analStockMBActiveRequest = function analStockMBActiveRequest(params) {
  return {
    type: ANAL_STOCK_MB_ACTIVE_REQUESTING,
    params,
  };
};

export const analStockMBActiveSuccess = function analStockMBActiveSuccess(resData) {
  return {
    type: ANAL_STOCK_MB_ACTIVE_SUCCESS,
    resData,
  };
};

export const analStockMBActiveError = function analStockMBActiveError(error) {
  return {
    type: ANAL_STOCK_MB_ACTIVE_ERROR,
    error,
  };
};

/** mua bán nước ngoài trong ngày */
export const analNNIndayRequest = function analNNIndayRequest(params) {
  return {
    type: ANAL_NN_INDAY_REQUESTING,
    params,
  };
};

export const analNNIndaySuccess = function analNNIndaySuccess(resData) {
  return {
    type: ANAL_NN_INDAY_SUCCESS,
    resData,
  };
};

export const analNNIndayError = function analNNIndayError(error) {
  return {
    type: ANAL_NN_INDAY_ERROR,
    error,
  };
};

/** mua bán nước ngoài 10 phiên */
export const analNN10dayRequest = function analNN10dayRequest(params) {
  return {
    type: ANAL_NN_10DAY_REQUESTING,
    params,
  };
};

export const analNN10daySuccess = function analNN10daySuccess(resData) {
  return {
    type: ANAL_NN_10DAY_SUCCESS,
    resData,
  };
};

export const analNN10dayError = function analNN10dayError(error) {
  return {
    type: ANAL_NN_10DAY_ERROR,
    error,
  };
};

/** phân bổ dòng tiền */
export const analPBDongTienRequest = function analPBDongTienRequest(params) {
  return {
    type: ANAL_PB_DONG_TIEN_REQUESTING,
    params,
  };
};

export const analPBDongTienSuccess = function analPBDongTienSuccess(resData) {
  return {
    type: ANAL_PB_DONG_TIEN_SUCCESS,
    resData,
  };
};

export const analPBDongTienError = function analPBDongTienError(error) {
  return {
    type: ANAL_PB_DONG_TIEN_ERROR,
    error,
  };
};

/** lịch sử giá */
export const analLichSuGiaRequest = function analLichSuGiaRequest(params) {
  return {
    type: ANAL_LICH_SU_GIA_REQUESTING,
    params,
  };
};

export const analLichSuGiaSuccess = function analLichSuGiaSuccess(resData) {
  return {
    type: ANAL_LICH_SU_GIA_SUCCESS,
    resData,
  };
};

export const analLichSuGiaError = function analLichSuGiaError(error) {
  return {
    type: ANAL_LICH_SU_GIA_ERROR,
    error,
  };
};

/** security basic info */
export const analBasicInfoRequest = function analBasicInfoRequest(params) {
  return {
    type: ANAL_BASIC_INFO_REQUESTING,
    params,
  };
};

export const analBasicInfoSuccess = function analBasicInfoSuccess(resData) {
  return {
    type: ANAL_BASIC_INFO_SUCCESS,
    resData,
  };
};

export const analBasicInfoError = function analBasicInfoError(error) {
  return {
    type: ANAL_BASIC_INFO_ERROR,
    error,
  };
};

/** fs ratios*/
export const analFSRatioRequest = function analFSRatioRequest(params) {
  return {
    type: ANAL_FS_RATIO_REQUESTING,
    params,
  };
};

export const analFSRatioSuccess = function analFSRatioSuccess(resData) {
  return {
    type: ANAL_FS_RATIO_SUCCESS,
    resData,
  };
};

export const analFSRatioError = function analFSRatioError(error) {
  return {
    type: ANAL_FS_RATIO_ERROR,
    error,
  };
};

/** ranking fs ratios*/
export const analRankFSRatioRequest = function analRankFSRatioRequest(params) {
  return {
    type: ANAL_RANK_FS_RATIO_REQUESTING,
    params,
  };
};

export const analRankFSRatioSuccess = function analRankFSRatioSuccess(resData) {
  return {
    type: ANAL_RANK_FS_RATIO_SUCCESS,
    resData,
  };
};

export const analRankFSRatioError = function analRankFSRatioError(error) {
  return {
    type: ANAL_RANK_FS_RATIO_ERROR,
    error,
  };
};

/** sec overview*/
export const analSecOverviewRequest = function analSecOverviewRequest(params) {
  return {
    type: ANAL_SEC_OVERVIEW_REQUESTING,
    params,
  };
};

export const analSecOverviewSuccess = function analSecOverviewSuccess(resData) {
  return {
    type: ANAL_SEC_OVERVIEW_SUCCESS,
    resData,
  };
};

export const analSecOverviewError = function analSecOverviewError(error) {
  return {
    type: ANAL_SEC_OVERVIEW_ERROR,
    error,
  };
};

/** company introduction */
export const analComIntroductionRequest = function analComIntroductionRequest(params) {
  return {
    type: ANAL_COMPANY_INTRODUCTION_REQUESTING,
    params,
  };
};

export const analComIntroductionSuccess = function analComIntroductionSuccess(resData) {
  return {
    type: ANAL_COMPANY_INTRODUCTION_SUCCESS,
    resData,
  };
};

export const analComIntroductionError = function analComIntroductionError(error) {
  return {
    type: ANAL_COMPANY_INTRODUCTION_ERROR,
    error,
  };
};

/** company basic */
export const analComBasicRequest = function analComBasicRequest(params) {
  return {
    type: ANAL_COMPANY_BASIC_REQUESTING,
    params,
  };
};

export const analComBasicSuccess = function analComBasicSuccess(resData) {
  return {
    type: ANAL_COMPANY_BASIC_SUCCESS,
    resData,
  };
};

export const analComBasicError = function analComBasicError(error) {
  return {
    type: ANAL_COMPANY_BASIC_ERROR,
    error,
  };
};

/** company same industry */
export const analComSameIndustryRequest = function analComSameIndustryRequest(params) {
  return {
    type: ANAL_COMPANY_SAME_IND_REQUESTING,
    params,
  };
};

export const analComSameIndustrySuccess = function analComSameIndustrySuccess(resData) {
  return {
    type: ANAL_COMPANY_SAME_IND_SUCCESS,
    resData,
  };
};

export const analComSameIndustryError = function analComSameIndustryError(error) {
  return {
    type: ANAL_COMPANY_SAME_IND_ERROR,
    error,
  };
};

/** company leader */
export const analComLeaderRequest = function analComLeaderRequest(params) {
  return {
    type: ANAL_COMPANY_LEADER_REQUESTING,
    params,
  };
};

export const analComLeaderSuccess = function analComLeaderSuccess(resData) {
  return {
    type: ANAL_COMPANY_LEADER_SUCCESS,
    resData,
  };
};

export const analComLeaderError = function analComLeaderError(error) {
  return {
    type: ANAL_COMPANY_LEADER_ERROR,
    error,
  };
};

/** company holder */
export const analComHolderRequest = function analComHolderRequest(params) {
  return {
    type: ANAL_COMPANY_HOLDER_REQUESTING,
    params,
  };
};

export const analComHolderSuccess = function analComHolderSuccess(resData) {
  return {
    type: ANAL_COMPANY_HOLDER_SUCCESS,
    resData,
  };
};

export const analComHolderError = function analComHolderError(error) {
  return {
    type: ANAL_COMPANY_HOLDER_ERROR,
    error,
  };
};

/** company events */
export const analComEventsRequest = function analComEventsRequest(params) {
  return {
    type: ANAL_COMPANY_EVENTS_REQUESTING,
    params,
  };
};

export const analComEventsSuccess = function analComEventsSuccess(resData) {
  return {
    type: ANAL_COMPANY_EVENTS_SUCCESS,
    resData,
  };
};

export const analComEventsError = function analComEventsError(error) {
  return {
    type: ANAL_COMPANY_EVENTS_ERROR,
    error,
  };
};

/** company big trans */
export const analComBigTransRequest = function analComBigTransRequest(params) {
  return {
    type: ANAL_COMPANY_BIGTRANS_REQUESTING,
    params,
  };
};

export const analComBigTransSuccess = function analComBigTransSuccess(resData) {
  return {
    type: ANAL_COMPANY_BIGTRANS_SUCCESS,
    resData,
  };
};

export const analComBigTransError = function analComBigTransError(error) {
  return {
    type: ANAL_COMPANY_BIGTRANS_ERROR,
    error,
  };
};

/** công ty liên kết */
export const analComRelatedRequest = function analComRelatedRequest(params) {
  return {
    type: ANAL_COMPANY_RELATED_REQUESTING,
    params,
  };
};

export const analComRelatedSuccess = function analComRelatedSuccess(resData) {
  return {
    type: ANAL_COMPANY_RELATED_SUCCESS,
    resData,
  };
};

export const analComRelatedError = function analComRelatedError(error) {
  return {
    type: ANAL_COMPANY_RELATED_ERROR,
    error,
  };
};

/** filter range */
export const analFilterRangeRequest = function analFilterRangeRequest(params) {
  return {
    type: ANAL_FILTER_RANGE_REQUESTING,
    params,
  };
};

export const analFilterRangeSuccess = function analFilterRangeSuccess(resData) {
  return {
    type: ANAL_FILTER_RANGE_SUCCESS,
    resData,
  };
};

export const analFilterRangeError = function analFilterRangeError(error) {
  return {
    type: ANAL_FILTER_RANGE_ERROR,
    error,
  };
};

/** filter action */
export const analFilterActionRequest = function analFilterActionRequest(params) {
  return {
    type: ANAL_FILTER_ACT_REQUESTING,
    params,
  };
};

export const analFilterActionSuccess = function analFilterActionSuccess(resData) {
  return {
    type: ANAL_FILTER_ACT_SUCCESS,
    resData,
  };
};

export const analFilterActionError = function analFilterActionError(error) {
  return {
    type: ANAL_FILTER_ACT_ERROR,
    error,
  };
};

/** user filter  */
export const analUserFilterRequest = function analUserFilterRequest(params) {
  return {
    type: ANAL_USER_FILTER_REQUESTING,
    params,
  };
};

export const analUserFilterSuccess = function analUserFilterSuccess(resData) {
  return {
    type: ANAL_USER_FILTER_SUCCESS,
    resData,
  };
};

export const analUserFilterError = function analUserFilterError(error) {
  return {
    type: ANAL_USER_FILTER_ERROR,
    error,
  };
};

/** danh sach tin hieu da dang kys */
export const analUserSignalRequest = function analUserSignalRequest(params) {
  return {
    type: ANAL_USER_SIGNAL_REQUESTING,
    params,
  };
};

export const analUserSignalSuccess = function analUserSignalSuccess(resData) {
  return {
    type: ANAL_USER_SIGNAL_SUCCESS,
    resData,
  };
};

export const analUserSignalError = function analUserSignalError(error) {
  return {
    type: ANAL_USER_SIGNAL_ERROR,
    error,
  };
};

/** Xóa bộ lọc đã đăng ký */
export const analDelFilterRequest = function analDelFilterRequest(params) {
  return {
    type: ANAL_DEL_FILTER_REQUESTING,
    params,
  };
};

export const analDelFilterSuccess = function analDelFilterSuccess(resData) {
  return {
    type: ANAL_DEL_FILTER_SUCCESS,
    resData,
  };
};

export const analDelFilterError = function analDelFilterError(error) {
  return {
    type: ANAL_DEL_FILTER_ERROR,
    error,
  };
};
